import L from 'leaflet';

export default new L.Icon({
  iconUrl: '/icons/kindergarten.svg',
  iconRetinaUrl: '/icons/kindergarten.svg',
  iconAnchor: [0, 0],
  popupAnchor: [10, -5],
  iconSize: [20, 20],
});